<template>
  <div>
    <!-- Header START -->
    <Header />
    <!-- Header END -->
    <div class="content-wrapper">
      <!-- load components dynamically dependend on url params -->
      <!-- register -->
      <RegistrationForm v-if="target == 'anmeldung'" />
      <!-- edit -->
      <EditForm v-if="target == 'changegb'" />
      <!-- edit -->
      <EditFormTipi v-if="target == 'changetipi'" />
      <!-- confirm registration -->
      <ConfirmRegistrationForm v-if="target == 'register'" />
      <!-- unsubscribe -->
      <UnsubscribeForm v-if="target == 'abmeldung'" />
      <!-- confirm unsubscribe -->
      <ConfirmUnsubscribeForm v-if="target == 'unregister'" />
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import RegistrationForm from "./components/RegistrationForm";
import ConfirmRegistrationForm from "./components/ConfirmRegistrationForm";
import UnsubscribeForm from "./components/UnsubscribeForm";
import ConfirmUnsubscribeForm from "./components/ConfirmUnsubscribeForm";
import EditForm from "./components/EditForm";
import EditFormTipi from "./components/EditFormTipi";

export default {
  name: "App",
  components: {
    Header,
    RegistrationForm,
    ConfirmRegistrationForm,
    UnsubscribeForm,
    ConfirmUnsubscribeForm,
    EditForm,
    EditFormTipi,
  },
  data() {
    return {
      target: null,
      fromApp: false,
    };
  },
  methods: {
    observeHeight() {
      const resizeObserver = new ResizeObserver(function() {
        let elem = document.querySelector(".content-wrapper");
        let bgPosition = elem.offsetHeight / 2 - 250;
        elem.style = `background-position: left ${bgPosition}px`;
      });

      resizeObserver.observe(document.querySelector(".content-wrapper"));
    },
  },
  mounted() {
    let elem = document.querySelector(".section_wrapper.mcb-section-inner");
    let elemColumn = document.querySelector(
      "#Wrapper .mcb-wrap-inner .column.mcb-column"
    );
    let elemClearfix = document.querySelector(
      "#Wrapper .mcb-wrap-inner .clearfix"
    );
    let elemBody = document.querySelector(
      "#Wrapper .section.mcb-section:first-child"
    );

    if (elem) {
      elem.style = `max-width: 100% !important`;
    }

    if (elemColumn) {
      elemColumn.style = `margin-right: 0; margin-left: 0; max-width: 100%; width: 100%`;
    }
    if (elemClearfix) {
      elemClearfix.style = `margin-right: 0 !important; margin-left: 0 !important; max-width: 100% !important; width: 100% !important`;
    }
    if (elemBody) {
      elemBody.style = `background-color: #fff !important;`;
    }

    // this.observeHeight();

    // on load check if url params are set and set the in a variable
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // get paramaters by name
    const target = urlParams.get("target");
    const nlabmeldung = urlParams.get("nlabmeldung");
    const register = urlParams.get("register");
    const unregister = urlParams.get("unregister");
    const from = urlParams.get("from");
    const changegb = urlParams.get("changegb");
    const changetipi = urlParams.get("changetipi");
    // call the values from parameters and set them in variables
    if (from == "app") {
      this.fromApp = true;
    }
    // check which parameter is set and set target value to load components depended on them
    if (target == null) {
      this.target = "anmeldung";
    }
    if (nlabmeldung) {
      this.target = "abmeldung";
    }
    if (target == "abmeldung") {
      this.target = "abmeldung";
    }
    if (register) {
      this.target = "register";
    }
    if (unregister) {
      this.target = "unregister";
    }
    if (changegb) {
      this.target = "changegb";
    }
    if (changetipi) {
      this.target = "changetipi";
    }
  },
};
</script>
